export default function () {
  return {
    page: 1,
    totalPages: 0,
    perPage: 15,
    searchParams: {},
    items: [],
    fields: [
      {
        key: 'label',
        label: 'Nome'
      },
      {
        key: 'value',
        label: 'Valor atual',
      },
      {
        key: 'actions',
        label: 'Ações'
      }
    ]
  }
}
